/** Security remediation & server feature gates — rollback: SECURITY_ROLLBACK_NOTE.md */
export const APP_VERSION = '1.57.4'; // bump this every commit
